"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PortalBase = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _reactJss = require("react-jss");
var _ThemeProvider = _interopRequireDefault(require("../ThemeProvider"));
var _environmentCharacteristics = require("../utils/environmentCharacteristics");
var _omit = _interopRequireDefault(require("../utils/omit"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); } /**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var PortalBase = exports.PortalBase = function PortalBase(_ref) {
  var container = _ref.container,
    children = _ref.children;
  var theme = (0, _reactJss.useTheme)();
  if (!_environmentCharacteristics.isBrowser) {
    return null;
  }
  return /*#__PURE__*/(0, _reactDom.createPortal)(/*#__PURE__*/_react.default.createElement(_ThemeProvider.default, _extends({}, (0, _omit.default)(["withGlobalStyles"], theme.themeProviderProps), {
    nested: true
  }), children), container);
};
var _default = exports.default = PortalBase;